
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu/pizza",
      function () {
        return require("private-next-pages/menu/pizza/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menu/pizza"])
      });
    }
  